import { SIQReplyViewTheme } from "./SIQReplyViewTheme";
export class SIQChatInputTheme {
  backgroundColor = "null";
  audioRecordHintBackgroundColor = "null";
  audioRecordHintTextColor = "null";
  textFieldBorderColor = "null";
  textFieldTintColor = "null";
  textFieldBackgroundColor = "null";
  textFieldPlaceholderColor = "null";
  textFieldTextColor = "null";
  attachmentButtonBackgroundColor = "null";
  recordButtonBackgroundColor = "null";
  recordSoundPulseBackgroundColor = "null";
  sendButtonBackgroundColor = "null";
  buttonDisabledBackgroundColor = "null";
  recordTimerBackgroundColor = "null";
  recordTimerTextColor = "null";
  recordTimerIndicatorColor = "null";
  recordSlideTextColor = "null";
  recordSlideIconColor = "null";
  recordCancelTextColor = "null";
  moreIconColor = "null";
  sendIconColor = "null";
  recordIconColor = "null";
  Reply = new SIQReplyViewTheme();
  Edit = new SIQReplyViewTheme();
}
//# sourceMappingURL=SIQChatInputTheme.js.map